import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { OwnAdministrativeFeeDto } from '../models/ownadministrativefeedto';
import { PaginationFeaturesDto } from '../models/paginationfeaturesdto';
import { AppConfigService } from './core/appConfig.service';

@Injectable({
    providedIn: 'root'
})
export class OwnAdministrativeFeeService {

    constructor(private http: HttpClient, private configService:AppConfigService) { }

    /**
     * Función encargada de listar todas las tasas administrativas segun filtro
     * @param type
     * @param filter
     * @returns 
     */
    getListOwnAdministrativeFee(pageRequest: PaginationFeaturesDto, codeModel: any): Observable<any> {
        const params = new HttpParams()
            .set('page', pageRequest.page)
            .set('sizePage', pageRequest.sizePage)
            .set('orderField', pageRequest.orderField)
            .set('order', pageRequest.order);
        const url = `${this.configService.apiUrl}/configuration/own-management-fee/getAll?${params}&codeModel=${codeModel}`;
        return this.http.get<any>(url).pipe(map(response => { return response; }));
    }

    getOwnAdministrativeFeeById(id: number): Observable<OwnAdministrativeFeeDto> {
        const url = `${this.configService.apiUrl}/configuration/own-management-fee/filter/${id}`;
        return this.http.get<any>(url).pipe(map(response => { return new OwnAdministrativeFeeDto(response); }));
    }

    insertOwnAdministrativeFee(ownAdministrativeFee: OwnAdministrativeFeeDto): Observable<OwnAdministrativeFeeDto> {
        const idRateModel = ownAdministrativeFee.rateModelDto?.idRateModel;
        const idAdministrativeFeeCatalog = ownAdministrativeFee.administrativeFeeCatalogDto?.idAdministrativeFeesCatalog;
        const active = ownAdministrativeFee.active;
        const url = `${this.configService.apiUrl}/configuration/own-management-fee/insert/${idRateModel}/${idAdministrativeFeeCatalog}/${active}`;
        return this.http.post<any>(url, ownAdministrativeFee).pipe(map(response => { return new OwnAdministrativeFeeDto(response); }));
    }

    updateOwnAdministrativeFee(ownAdministrativeFee: OwnAdministrativeFeeDto): Observable<OwnAdministrativeFeeDto> {
        const idOwnAdministrativeFee = ownAdministrativeFee.idOwnAdministrativeFee;
        const idRateModel = ownAdministrativeFee.rateModelDto?.idRateModel;
        const idAdministrativeFeeCatalog = ownAdministrativeFee.administrativeFeeCatalogDto?.idAdministrativeFeesCatalog;
        const active = ownAdministrativeFee.active;
        const url = `${this.configService.apiUrl}/configuration/own-management-fee/${idOwnAdministrativeFee}/update/${idRateModel}/${idAdministrativeFeeCatalog}/${active}`;
        return this.http.put<any>(url, ownAdministrativeFee).pipe(map(response => { return new OwnAdministrativeFeeDto(response); }));
    }
}
